import { IonText, IonImg } from '@ionic/react';
import React from 'react';

const Logo: React.FC = () => {
    return (
        <IonText className="logo">
            <div>
                <IonImg className="img" src="../assets/images/output-onlinepngtools.png" />
            </div>
        </IonText>

    );
};

export default Logo;